(function () {
  'use strict';

  function getBookingRoots() {
    return document.querySelectorAll('.product__sesami-multi-product-booking[data-sesami-multi-product-cart]');
  }

  function getProductFormEl(bookingRoot) {
    var productInfo = bookingRoot.closest('product-info');
    return productInfo
      ? productInfo.querySelector('product-form')
      : document.querySelector('product-form');
  }

  function getRequiredCount(bookingRoot) {
    return getActiveForms(bookingRoot).length;
  }

  function shouldRedirectToCart(bookingRoot) {
    return bookingRoot.dataset.redirectToCart === 'true';
  }

  function getActiveForms(bookingRoot) {
    return Array.from(bookingRoot.querySelectorAll('.CartSesamiExperience__Form[data-sesami-slot]'));
  }

  function getHiddenWrappersInProductForm(bookingRoot) {
    var productFormEl = getProductFormEl(bookingRoot);
    if (!productFormEl) return [];

    return Array.from(productFormEl.querySelectorAll('.sesami-hidden-fields-wrapper'));
  }

  function getBookingDate(wrapper) {
    var dateInput =
      wrapper.querySelector('[sesami-hidden-date]') ||
      wrapper.querySelector('input[name="properties[Date]"]');

    if (!dateInput || !dateInput.value) return '';
    return String(dateInput.value).trim();
  }

  function collectItemFromWrapper(hiddenWrapper, variantId) {
    var date = getBookingDate(hiddenWrapper);
    if (!date) return null;

    var properties = {
      id: String(Math.floor(Math.random() * 10000) + 1)
    };

    hiddenWrapper.querySelectorAll('input').forEach(function (input) {
      if (!input.name || !input.value) return;

      if (input.name.indexOf('properties[') === 0) {
        var match = input.name.match(/^properties\[(.+)\]$/);
        if (match) properties[match[1]] = input.value;
      }
    });

    return {
      quantity: 1,
      id: parseInt(variantId, 10),
      properties: properties
    };
  }

  function findWrapperForForm(form, wrappers, index) {
    var wrapperInForm = form.querySelector('.sesami-hidden-fields-wrapper');
    if (wrapperInForm) return wrapperInForm;

    if (wrappers[index]) return wrappers[index];

    return null;
  }

  function collectQueue(bookingRoot) {
    var forms = getActiveForms(bookingRoot);
    var wrappers = getHiddenWrappersInProductForm(bookingRoot);
    var queue = [];

    forms.forEach(function (form, index) {
      var variantInput = form.querySelector('input[name="id"]');
      var variantId = (variantInput && variantInput.value) || form.dataset.variantId || '';
      var wrapper = findWrapperForForm(form, wrappers, index);

      if (!wrapper || !variantId) return;

      var item = collectItemFromWrapper(wrapper, variantId);
      if (item) queue.push(item);
    });

    return queue;
  }

  function getCartAddJsUrl() {
    var addUrl = (typeof routes !== 'undefined' && routes.cart_add_url) || '/cart/add';

    if (addUrl.indexOf('.js') !== -1) {
      return addUrl;
    }

    return addUrl.replace(/\/?$/, '') + '.js';
  }

  function parseCartResponse(response) {
    return response.text().then(function (text) {
      if (!text) {
        throw new Error('Empty response from cart (HTTP ' + response.status + ')');
      }

      var data;
      try {
        data = JSON.parse(text);
      } catch (error) {
        console.error(
          '[Sesami multi-product-cart] Non-JSON cart response (HTTP ' + response.status + '):',
          text.substring(0, 300)
        );
        throw new Error('Cart did not return JSON. Check variant ID and item properties.');
      }

      if (data.status) {
        throw new Error(data.description || data.message || 'Cart add failed');
      }

      return data;
    });
  }

  function postCartAdd(body) {
    return fetch(getCartAddJsUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(parseCartResponse);
  }

  function addItemToCart(item) {
    return postCartAdd({
      id: item.id,
      quantity: item.quantity,
      properties: item.properties
    });
  }

  function addAllItemsToCart(queue) {
    return postCartAdd({
      items: queue.map(function (item) {
        return {
          id: item.id,
          quantity: item.quantity,
          properties: item.properties
        };
      })
    });
  }

  function showError(bookingRoot) {
    var errorEl = bookingRoot.querySelector('.sesami-multi-product-booking__error');
    if (errorEl) errorEl.hidden = false;
  }

  function hideError(bookingRoot) {
    var errorEl = bookingRoot.querySelector('.sesami-multi-product-booking__error');
    if (errorEl) errorEl.hidden = true;
  }

  function setLoading(button, loading) {
    button.disabled = loading;
    button.classList.toggle('loading', loading);
  }

  function processQueue(queue, button, bookingRoot) {
    var addPromise = queue.length === 1 ? addItemToCart(queue[0]) : addAllItemsToCart(queue);

    addPromise
      .then(function () {
        setLoading(button, false);
        if (shouldRedirectToCart(bookingRoot)) {
          window.location.href = (typeof routes !== 'undefined' && routes.cart_url) || '/cart';
        }
      })
      .catch(function (error) {
        console.error('[Sesami multi-product-cart] Cart add failed', error, queue);
        setLoading(button, false);
        showError(button.closest('.product__sesami-multi-product-booking'));
      });
  }

  function addPackageToCart(bookingRoot, addToCartButton) {
    hideError(bookingRoot);
    setLoading(addToCartButton, true);

    var requiredCount = getRequiredCount(bookingRoot);
    var activeForms = getActiveForms(bookingRoot);

    if (requiredCount === 0) {
      setLoading(addToCartButton, false);
      showError(bookingRoot);
      return;
    }

    if (activeForms.length !== requiredCount) {
      console.error(
        '[Sesami multi-product-cart] Form count mismatch',
        activeForms.length,
        requiredCount
      );
      setLoading(addToCartButton, false);
      showError(bookingRoot);
      return;
    }

    var queue = collectQueue(bookingRoot);

    if (queue.length !== requiredCount) {
      console.group('[Sesami multi-product-cart] Validation failed');
      console.log('Required experiences:', requiredCount);
      console.log('Filled experiences found:', queue.length);
      console.log(
        'Forms:',
        activeForms.map(function (form, index) {
          return {
            slot: form.dataset.sesamiSlot,
            variantId: form.dataset.variantId,
            date: getBookingDate(findWrapperForForm(form, getHiddenWrappersInProductForm(bookingRoot), index) || document.createElement('div'))
          };
        })
      );
      console.groupEnd();
      setLoading(addToCartButton, false);
      showError(bookingRoot);
      return;
    }

    processQueue(queue, addToCartButton, bookingRoot);
  }

  function bindAddToCart(bookingRoot) {
    var addToCartButton = bookingRoot.querySelector('.sesami-multi-product-cart-submit');
    if (!addToCartButton) return;

    addToCartButton.addEventListener('click', function () {
      addPackageToCart(bookingRoot, addToCartButton);
    });
  }

  function initBookingRoot(bookingRoot) {
    if (bookingRoot.dataset.sesamiMultiProductCartBound === 'true') return;
    bookingRoot.dataset.sesamiMultiProductCartBound = 'true';
    bindAddToCart(bookingRoot);
  }

  function init() {
    getBookingRoots().forEach(initBookingRoot);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
